import {
    type TypedUseSelectorHook,
    useSelector,
} from "react-redux";
import { type AnyAction } from "redux";
import { type ThunkDispatch } from "redux-thunk";
import { type RootState } from "../Reducers/DeveloperReducers";

export type DeveloperDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const useDeveloperSelector: TypedUseSelectorHook<RootState> = useSelector;
